<template>
  <div class="game-info">
    <h2>{{ message }}</h2>

    <div class="controls">
      <button @click="$emit('reset')" :disabled="isThinking">重新开始</button>

      <select :value="gameMode" @change="$emit('update:gameMode', $event.target.value)" :disabled="isThinking">
        <option value="PVA">👤 人类 vs 🤖 AI</option>
        <option value="PVP">👤 人类 vs 👤 人类</option>
      </select>
    </div>

  </div>
</template>

<script>
export default {
  name: 'GameInfo',
  // --- 移除了所有联机相关的 props ---
  props: {
    currentPlayer: Number,
    winner: [Number, String],
    gameMode: String,
    isThinking: Boolean,
  },
  // --- 移除了所有联机相关的 data ---
  data() {
    return {
      // (showJoinDialog, joinRoomId, chatMessage, debugMode 均已移除)
    };
  },
  computed: {
    message() {
      if (this.winner) {
        if (this.winner === 'draw') {
          return '平局！';
        }
        return this.winner === 1 ? '🎉 黑子胜利！' : '🎉 白子胜利！';
      }
      if (this.isThinking) {
        return '🤖 AI 正在思考...';
      }
      return `当前回合: ${this.currentPlayer === 1 ? '⚫ 黑子' : '⚪ 白子'}`;
    },
    // --- 移除了 connectionStatusText ---
  },
  // --- 移除了所有联机相关的 methods ---
  methods: {
    // (sendChat, joinRoom, toggleDebug 均已移除)
  }
}
</script>

<style scoped>
.game-info {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 600px; /* 与棋盘宽度协调 */
  color: white;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

.game-info h2 {
  margin: 0 0 15px 0;
  font-size: 1.5rem;
}

.controls {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap; /* 允许在小屏幕上换行 */
}

.controls button,
.controls select {
  padding: 10px 15px;
  font-size: 1rem;
  border-radius: 5px;
  border: none;
  background: #fff;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
}

.controls button:hover,
.controls select:hover {
  background-color: #f0f0f0;
}

.controls button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* 移除了所有 .debug-info, .chat-section, .connection-status, .online-controls 等样式 */
</style>
